import { query, where } from 'firebase/firestore';

/**
 * Her Firestore sorgusuna otomatik businessId filtresi ekler.
 * businessId boşsa hata fırlatır — tenant izolasyonu sessizce atlanamaz.
 *
 * @param {import('firebase/firestore').CollectionReference} collectionRef
 * @param {string} businessId
 * @param {...import('firebase/firestore').QueryConstraint} additionalConstraints
 */
export function tenantQuery(collectionRef, businessId, ...additionalConstraints) {
  if (!businessId) {
    throw new Error('tenantQuery: businessId zorunlu — global sorgu yasak (bkz. v2-saas-plan.md §3.1)');
  }
  return query(
    collectionRef,
    where('businessId', '==', businessId),
    ...additionalConstraints
  );
}
